import React from 'react'

import classNames from 'classnames'

interface Props {
  variant?: 'primary' | 'secondary'
  children?: React.ReactNode
  className?: string
}

const Badge: React.FC<Props> = ({ children, variant, className }: Props) => (
  <div
    className={classNames(
      'py-0.5 rounded-xl px-2 text-xxs',
      {
        'bg-orange text-white': variant === 'primary',
        'bg-gray-tabs': variant === 'secondary',
      },
      className
    )}>
    {children}
  </div>
)

Badge.defaultProps = {
  variant: 'primary',
}

export default Badge
